module.exports = __webpack_public_path__ + "static/media/menu-arrow.953fcf2b.svg";